<template>
  <div>
    <md-dialog class="fullImage"> </md-dialog>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import Vue from "vue";
Vue.use(VueViewer);
export default {
  name: "FullSizeImage",
  props: ["images"],
  methods: {
    openDialog() {
      this.show();
    },
    close() {
      this.$emit("close");
    },
    show() {
      this.$viewerApi({
        images: this.images,
      });
    },
  },
  setImage(image) {
    this.image = image;
  },
};
</script>

<style lang="scss">
.md-overlay {
  z-index: -1 !important;
}
.viewer-backdrop {
  background-color: rgba(255, 255, 255, 90%);
}
</style>
